<template>
  <div>
    <header1 title="用户注册"></header1>
    <div class="new_content" style="background:#FFFFFF;width:1002px;">
      <p style="height: 40px; padding-left: 20px; line-height: 40px; font-size: 14px; font-weight: bold;"><span
        style="color:#1D7A8E;">提醒：</span>为了保证您第一时间获取培训有效证书，请如实填写以下注册信息，避免重复注册。</p>
      <el-form ref="form" :model="form" :rules="rules"
        label-width="90px" style="padding: 30px;border:2px #F1F1F1 solid;color:#5F5F5F; font-size: 14px;">
        <el-form-item label="证件类型" prop="cardType">
          <el-select v-model="form.cardType" placeholder="请选择证件类型">
            <el-option v-for="item in cardTypeOptions" :key="item.key" :label="item.value"
              :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号" prop="sertId" style="width:46%">
          <el-input v-model="form.sertId" placeholder="请输入18位证件号"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="username" style="width:46%">
          <el-input v-model="form.username" placeholder="用户名为6-20个字符，且字母在首位"></el-input>
        </el-form-item>
        <!--<el-form-item label="密码" prop="password" style="width:46%">-->
        <!--  <el-input v-model="form.password" placeholder="6-22个字符，数字、字母、特殊符号，区分大小写"-->
        <!--    type="password"></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="确认密码" prop="vpassword" style="width:46%">-->
        <!--  <el-input v-model="form.vpassword" placeholder="请再一次输入密码" type="password"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item :show-message="false" class="no_margin_bottom" label="密码" prop="password" style="width: 48%">
          <el-input v-model.trim="form.password" :maxLength="16" :type="form.showPassword ? 'text' : 'password'"
            autocomplete="new-password" placeholder="请输入符合规则的密码">
            <i slot="suffix" :class="['el-input__icon', form.showPassword ? 'ri-eye-fill' : 'ri-eye-off-fill']"
              @click="form.showPassword = !form.showPassword"></i>
          </el-input>
          <div class="form_password_verifiers">
            <el-tag :type="PasswordLengthRge().test(form.password) ? 'success' : 'info'" hit>
              <i class="el-icon-success"></i>8-16位之间
            </el-tag>
            <el-tag :type="UppercaseLowercaseReg().test(form.password) ? 'success' : 'info'" hit>
              <i class="el-icon-success"></i>含大小写字母
            </el-tag>
            <el-tag :type="NumberReg().test(form.password) ? 'success' : 'info'" hit>
              <i class="el-icon-success"></i>含数字
            </el-tag>
            <el-tag :type="SpecialCharactersReg().test(form.password) ? 'success' : 'info'" hit>
              <i
                class="el-icon-success"></i>含特殊字符，如:@#*
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="vpassword" style="width: 48%">
          <el-input v-model.trim="form.vpassword" :type="form.showVpassword ? 'text' : 'password'"
            autocomplete="new-password"
            placeholder="请再一次输入密码">
            <i slot="suffix" :class="['el-input__icon', form.showVpassword ? 'ri-eye-fill' : 'ri-eye-off-fill']"
              @click="form.showVpassword = !form.showVpassword"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realname" style="width:100%">
          <el-row>
            <el-col :span="10">
              <el-input v-model="form.realname" placeholder="请输入有效证件上的姓名，不要使用空格"></el-input>
            </el-col>
            <el-col :span="7">
              <el-button style="padding-left: 5px;" type="text"> ※颁发证书时将使用此名字，请如实填写！</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="form.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item v-show="!form.isCustomComp" label="所在单位" prop="company">
          <!--非自填单位-->
          <el-row>
            <el-col :span="12">
              <el-select v-model="form.company"
                :loading="compLoading"
                :no-data-text="compPrompt"
                :remote-method="remoteSearchComp"
                filterable
                placeholder="请输入关键词"
                remote
                style="width: 100%">
                <el-option
                  v-for="item in compOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <span style="float: left">{{ item.name }}</span>
                  <span
                    style="float: right; color: #8492A6; font-size: 13px;margin-left: 10px">{{ formatRegion(item.province, item.city, item.county, item.rural)
                    }}</span>
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-popover ref="popover1"
                v-model="customCompVisible"
                placement="top"
                trigger="hover"
                width="200">
                <p>搜索单位时无需填写省市县名称，只需填写医院关键字即可，或者可以选择
                  <el-button size="mini" type="text" @click="showCustomComp()">切换自填单位</el-button>
                </p>
              </el-popover>
              <el-button v-show="searchCount>=5" v-popover:popover1 type="text"> 找不到单位？</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        
        <el-form-item v-show="form.isCustomComp" label="自填单位" prop="company">
          <!--自填单位-->
          <el-row>
            <el-col :span="4">
              <el-select v-model="form.customCompForm.province" clearable placeholder="省" @change="changeArea">
                <el-option
                  v-for="item in provinceOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select v-model="form.customCompForm.city" clearable placeholder="市" @change="changeArea">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select v-model="form.customCompForm.county" clearable placeholder="县" @change="changeArea">
                <el-option
                  v-for="item in countyOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select v-model="form.customCompForm.rural" clearable placeholder="乡">
                <el-option
                  v-for="item in ruralOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-col>
            <el-col :offset="1" :span="7">
              <el-input v-model.trim="form.customCompForm.compName" placeholder="单位名称"></el-input>
            </el-col>
          </el-row>
          <el-button type="text" @click="swithSelectComp">选择已有单位</el-button>
        </el-form-item>
        <el-form-item label="所在科室" prop="department">
          <el-autocomplete
            v-model="form.department"
            :fetch-suggestions="searchDepartment"
            placeholder="请输入内容"
            @select="departmentSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="人员类别" prop="personType">
          <el-select v-model="form.personType" placeholder="请选择人员类别" @change="changePersonType">
            <el-option v-for="item in personTypeOptions" :key="item.key" :label="item.value"
              :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业" prop="specialty">
          <el-select v-model="form.specialtyId1" placeholder="请选择专业1" @change="changeSpecialtyId1">
            <el-option v-for="item in specialtyId1Options" :key="item.key" :label="item.value"
              :value="item.key"></el-option>
          </el-select>
          <el-select v-model="form.specialtyId2" placeholder="请选择专业2">
            <el-option v-for="item in specialtyId2Options" :key="item.key" :label="item.value"
              :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职称" prop="title">
          <el-select v-model="form.title" placeholder="请选择职称">
            <el-option v-for="item in titleOptions" :key="item.key" :label="item.value"
              :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="乡村医生" prop="countryDoctor">
          <el-select v-model="form.countryDoctor" placeholder="请选择">
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
            <!--<el-option :value="-1" label="未定义"></el-option>-->
          </el-select>
        </el-form-item>
        <!--<el-form-item label="图形验证码" prop="vcode">-->
        <!--  <el-row>-->
        <!--    <el-col :span="5">-->
        <!--      <el-input v-model="form.vcode"></el-input>-->
        <!--    </el-col>-->
        <!--    <el-col :span="17">-->
        <!--      <img :src="captchaUrl" alt=""-->
        <!--        style="margin-left: 5px;width: 100px;border: 0" @click="refreshCaptcha"/>-->
        <!--    </el-col>-->
        <!--  </el-row>-->
        <!--</el-form-item>-->
        <el-form-item label="手机号" prop="mobile">
          <el-row>
            <el-col :span="5">
              <!-- 滑块验证 -->
              <div v-show="verifyShow" class="verifyMain">
                <Verify
                  ref="verify"
                  :captchaType="'blockPuzzle'"
                  :imgSize="{
                    width: '240px',
                    height: '120px',
                  }"
                  :mode="'fixed'"
                  @success="success"
                ></Verify>
                <div v-show="verifyOK" class="verifyOK">
                  <i
                    class="el-icon-success"
                    style="color:#67C23A;margin-left:12px;margin-right:8px"
                  ></i>
                  验证通过
                </div>
              </div>
              <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
            </el-col>
            <el-col :span="17">
              <el-button :disabled="sendSmsButtonDisabled" style="margin-left: 5px;" @click="sendSmsMethod">
                {{ sendSmsButtonText }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="短信验证码" prop="mobileCode">
          <el-row>
            <el-col :span="5">
              <el-input v-model="form.mobileCode"></el-input>
            </el-col>
            <el-col :span="17">
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item style="text-align:center">
            <input v-model="agreeContract" required type="checkbox" />
           <span style="font-size:12px;vertical-align:bottom">
            已阅读并同意
            <a href="https://source.yiboshi.com/licence/0417_shiyan/user.html" style="color:#38BCD5;">《用户协议》</a>和
            <a href="https://source.yiboshi.com/licence/0417_shiyan/pryvacy.html" style="color:#38BCD5;">《保护政策》</a>
          </span>
            <br/>
          <el-button :disabled="!agreeContract" :loading="registerLoading"
            style="width:30%;background: #1D7A8E;border-color: #1D7A8E;"
            type="primary" @click="onSubmit">{{ registerText }}
          </el-button>
          <br/>
          <!-- <input v-model="agreeContract" required type="checkbox"/>
          <router-link style="font-size: 12px; line-height: 50px;" target="_blank" to="/contract">
            我已阅读并接受用户服务条款
          </router-link> -->
        </el-form-item>
      </el-form>
    </div>
    <div style="width:1002px;margin: 0 auto;">
      <footer1></footer1>
    </div>
  </div>
</template>

<script>
import {
  checkUsername,
  getCustomAreaList,
  getdepartmentByOrgId,
  getSpecialty1Indexs,
  getSpecialty2Indexs,
  getUserDictByColumType,
  listByCompName,
  nameSertIdAvailable,
  studyRegister,
  valilCaptcha
} from '../api/api'
import util from '../common/js/util'
import { mapActions } from 'vuex'
import header1 from '../components/Header1'
import footer1 from '../components/Footer1'
import md5 from 'crypto-js/md5'
import { NumberReg, PasswordLengthRge, phoneReg, SpecialCharactersReg, UppercaseLowercaseReg } from '../utils/commonReg'
import { getsms, smsvalidate } from '../api/apiLoginVerify'
import { aesEncryptWord } from '../components/verifition/utils/ase'
import { isChineseIdCard } from '../utils/validate.js'
import Verify from '../components/verifition/Verify'

export default {
  components: {
    header1,
    footer1,
    Verify
  },
  data() {
    const passwordValidator = (rule, value, callback) => {
      const PasswordReg =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-/:;()$&@.,?!‘’[\]{}#%^*+=_\|~<>\\•])[a-zA-Z0-9-/:;()$&@.,?!‘’[\]{}#%^*+=_\|~<>\\•]{8,16}$/g
      if (PasswordReg.test(value)) {
        callback()
      } else {
        callback(new Error('密码不符合规范'))
      }
    }
    var validateRealname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入真实姓名'))
      } else {
        var flag = false
        //var pattern =  new RegExp("[`~!@#$%^&*()/=-|{}':;'·,-\\[\\]\\s\\+.<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
        var pattern = new RegExp('^[A-Za-z0-9\u4e00-\u9fa5]+$')
        if (!pattern.test(value)) {
          callback(new Error('请输入真实姓名,不能带有空格和特殊字符'))
        } else {
          callback()
        }
      }
    }
    var validateSertId = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入证件号'))
      } else if (this.form.cardType === '') {
        callback(new Error('请选择证件类型'))
      } else {
        if (this.form.cardType === '1' && !util.checkIdcard18(value)) {
          callback(new Error('证件号有误，请核实'))
        } else {
          nameSertIdAvailable({
            type: 2,
            credentialsType: this.form.cardType,
            value: value
          }).then(({data}) => {
            if (data.code == 0) {
              callback()
            } else {
              callback(new Error(data.msg))
            }
          })
          // sertIdAvailable({ sertId: value }).then(({ data }) => {
          //   if (data.available) {
          //     callback();
          //   } else {
          //     callback(new Error("证件号重复"));
          //   }
          // });
        }
      }
      // if (value === '') {
      //   callback(new Error('请输入证件号'))
      // } else if (this.form.cardType === '') {
      //   callback(new Error('请选择证件类型'))
      // } else {
      //   if (this.form.cardType === '1') {
      //     if (!util.checkIdcard18(value)) {
      //       callback(new Error('证件号有误，请核实'))
      //     } else {
      //       verificationStudent({sertId: value}).then((response) => {
      //         let {data} = response
      //         if (!data) {
      //           callback()
      //         } else {
      //           callback(new Error('该证件号已被注册'))
      //         }
      //       })
      //     }
      //   } else {
      //     verificationStudent({sertId: value}).then((response) => {
      //       let {data} = response
      //       if (!data) {
      //         callback()
      //       } else {
      //         callback(new Error('证件号重复'))
      //       }
      //     })
      //   }
      // }
    }
    var validateUsername = (rule, value, callback) => {
      var reg = /^[a-zA-Z][a-zA-Z0-9]*$/
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else if (isChineseIdCard(value)) {
        callback(new Error('身份证不可作为用户名'))
      } else if (reg.test(value) === false) {
        callback(new Error('用户名为6-20个字符，且字母在首位'))
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error('用户名为6-20个字符，且字母在首位'))
      } else {
        checkUsername({username: value}).then((response) => {
          let {data} = response
          if (!data) {
            callback()
          } else {
            callback(new Error('该用户名已被其他用户使用，请更换其他用户名'))
          }
        })
      }
    }
    var validateVpassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validateCompany = (rule, value, callback) => {
      if (this.form.isCustomComp) {
        if (!this.form.customCompForm.province || !this.form.customCompForm.city) {
          callback(new Error('自填单位至少填写到市一级'))
        } else if (!this.form.customCompForm.compName) {
          callback(new Error('请输入您的单位名称'))
        } else {
          callback()
        }
      } else {
        if (!value) {
          callback(new Error('请选择您所在的单位'))
        } else {
          callback()
        }
      }
    }
    var validateSpecialty = (rule, value, callback) => {
      if (!this.form.personType) {
        callback(new Error('请先选择人员类别'))
      } else if (!this.form.specialtyId1) {
        callback(new Error('请选择专业一'))
      } else if (!this.form.specialtyId2) {
        callback(new Error('请选择专业二'))
      } else {
        callback()
      }
    }
    var validateVCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请先输入图形验证码'))
      } else {
        valilCaptcha({key: this.vcodeuuid, code: this.form.vcode}).then((response) => {
          let {data} = response
          if (response.status == 200) {
            if (data) {
              callback()
            } else {
              callback(new Error('图形验证码错误'))
            }
          } else {
            callback(new Error('图形验证码错误'))
          }
        })
      }
    }
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
        // nameSertIdAvailable({ type: 3, value: value }).then(({ data }) => {
        //   if (data.code == 0) {
        //     callback()
        //   } else {
        //     callback(new Error(data.msg))
        //   }
        // })
        // loginnameAvailable({ value: value }).then(({ data }) => {
        //   if (data.available) {
        //     callback();
        //   } else {
        //     callback(new Error("手机号重复"));
        //   }
        // });
      }
    }
    const validateMobileCodeM = (rule, value, callback) => {
      if (!this.form.mobile) {
        callback(new Error('请先获取手机验证码'))
      } else if (!value) {
        callback(new Error('请输入手机验证码'))
      } else {
        callback()
        // validateMobileCode({mobile: this.form.phone, code: value}).then((response) => {
        //   let {data} = response
        //   if (response.status == 200) {
        //     if (data.status == 200) {
        //       callback()
        //     } else {
        //       callback(new Error('手机验证码错误'))
        //     }
        //   } else {
        //     callback(new Error('手机验证码错误'))
        //   }
        // })
      }
    }
    return {
      phoneReg: phoneReg,
      captchaUrl: '',
      form: {
        cardType: '1',
        sertId: '',
        username: '',
        password: '',
        vpassword: '',
        realname: '',
        sex: '',
        province: '',
        city: '',
        county: '',
        rural: '',
        isCustomComp: false,
        company: '',
        customCompForm: {
          province: '',
          city: '',
          county: '',
          rural: '',
          compName: ''
        },
        department: '',
        departmentId: '',
        personType: '',
        specialtyId1: '',
        specialtyId2: '',
        title: '',
        countryDoctor: '', // 是否乡村医生
        vcode: '',
        vcodeuuid: '',
        mobile: '',
        mobileCode: ''
      },
      rules: {
        cardType: [
          {required: true, message: '请选择证件类型', trigger: 'change'}
        ],
        sertId: [
          {required: true, validator: validateSertId, trigger: 'blur'}
        ],
        username: [
          {required: true, validator: validateUsername, trigger: 'blur'}
        ],
        password: [
          {required: true, validator: passwordValidator, trigger: 'change'}
        ],
        vpassword: [
          {required: true, validator: validateVpassword, trigger: 'blur'}
        ],
        realname: [
          {required: true, validator: validateRealname, trigger: 'blur'}
        ],
        sex: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        company: [
          {required: true, validator: validateCompany, trigger: 'blur,change'}
        ],
        department: [
          {required: true, message: '请输入科室', trigger: 'change'}
        ],
        personType: [
          {required: true, message: '请选择人员类别', trigger: 'change'}
        ],
        specialty: [
          {required: true, validator: validateSpecialty, trigger: 'change'}
        ],
        title: [
          {required: true, message: '请选择职称', trigger: 'change'}
        ],
        countryDoctor: [
          {required: true, message: '请选择乡村医生', trigger: 'change'}
        ],
        vcode: [
          {validator: validateVCode, trigger: 'blur'}
        ],
        mobile: [
          {validator: validateMobile, trigger: 'blur'}
        ],
        mobileCode: [
          {validator: validateMobileCodeM, trigger: 'blur'}
        ]
      },
      cardTypeOptions: [],//身份证类别
      personTypeOptions: [],//人员类别
      specialtyId1Options: [],//专业1
      specialtyId2Options: [],//专业2
      titleOptions: [],//职称
      compOptions: [],//单位下拉搜索
      compLoading: false,//单位下拉搜索的loading状态
      compPrompt: '无数据',//单位下拉无数据时的提示
      searchCount: 0,//单位搜索次数
      customCompVisible: false,//自填单位的显示
      provinceOptions: [],//省下拉
      cityOptions: [],//市下拉
      countyOptions: [],//县下拉
      ruralOptions: [],//乡下拉
      departmentList: [],//单位下的科室
      time: 0,
      sendSmsButtonDisabled: false,
      agreeContract: true, //是否同意条款
      registerLoading: false,
      registerText: '同意条款并注册',
      registerSuccessTime: 3,
      verifyOK: false,
      verifyShow: false,
      captchaVerification: {
        captchaVerification: ''
      }
    }
  },
  mounted() {
    this.refreshCaptcha()
    getUserDictByColumType({columnType: 1}).then((response) => {
      let {data} = response
      if (response.status == 200) {
        this.cardTypeOptions = data
      }
    })
    getUserDictByColumType({columnType: 2}).then((response) => {
      let {data} = response
      if (response.status == 200) {
        this.personTypeOptions = data
      }
    })
    getUserDictByColumType({columnType: 4}).then((response) => {
      let {data} = response
      if (response.status == 200) {
        this.titleOptions = data
      }
    })
  },
  computed: {
    sendSmsButtonText() {
      if (this.time > 0) {
        if (!this.sendSmsButtonDisabled) {
          this.sendSmsButtonDisabled = true
        }
        return this.time + 's 后重新获取'
      } else {
        this.sendSmsButtonDisabled = false
        return '获取验证码'
      }
    }
  },
  methods: {
    ...mapActions([
      'userLogin'
    ]),
    SpecialCharactersReg() {
      return SpecialCharactersReg
    },
    NumberReg() {
      return NumberReg
    },
    UppercaseLowercaseReg() {
      return UppercaseLowercaseReg
    },
    PasswordLengthRge() {
      return PasswordLengthRge
    },
    sendSmsMethod() {
      this.$refs.form.validateField('mobile', (error) => {
        if (!error) {
          this.verifyShow = true
          // 屏蔽获取验证码
          // this.captchaCode = "";
          // this.refreshCaptcha();
          // this.captchaVisible = true;
        }
      })
    },
    success(params) {
      // this.verifyOK = true
      this.captchaVerification = params
      // setTimeout(() => {
      //   this.verifyShow = false
      //   this.verifyOK = false
      // }, 1000)
      this.verifyShow = false
      //发送手机验证码
      this.sendyzm()
      
      /** 验证通过之后获取验证码**/
      // this.captchaCode = "";
    },
    /**
     * @description: 发送验证码
     */
    sendyzm() {
      let param = {
        mobile: aesEncryptWord(this.form.mobile),
        captchaVerification: this.captchaVerification.captchaVerification,
        flag: 2
      }
      getsms(param).then((res) => {
        this.$message.success('已发送手机验证码')
        this.time = 60
        this.smsTimer()
        this.mobileCodeKey = res.data.key
      })
    },
    smsTimer() {
      if (this.time > 0) {
        this.time--
        this.sendSmsButtonDisabled = true
        setTimeout(this.smsTimer, 1000)
      } else {
        this.sendSmsButtonDisabled = false
      }
    },
    remoteSearchComp(compName) {
      if (compName) {
        this.compLoading = true
        listByCompName({compName: compName.replace(/'/g, '')}).then((response) => {
          let {data} = response
          if (response.status == 200 && data.status == 200) {
            this.compOptions = data.data.list
            this.compLoading = false
            this.compPrompt = '无数据'
          } else {
            this.compOptions = []
            this.compPrompt = data.msg
            this.compLoading = false
          }
        })
        this.searchCount += 1
      } else {
        this.compOptions = []
        this.compPrompt = '请输入关键字'
      }
    },
    formatRegion(province, city, county, rural) {
      let result = province
      if (city) {
        result += '-' + city
        if (county) {
          result += '-' + county
          if (rural) {
            result += '-' + rural
          }
          
        }
      }
      return result
    },
    showCustomComp() {
      this.form.isCustomComp = true
      getCustomAreaList({
        isAccess: false,
        isSelect: true,
        isPleaseSelect: false,
        province: '',
        city: '',
        county: '',
        orgId: '10'
      }).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.provinceOptions = data
        }
      })
    },
    changeArea(val) {
      if (val) {
        getCustomAreaList({
          isAccess: false,
          isSelect: true,
          isPleaseSelect: false,
          province: '',
          city: '',
          county: '',
          orgId: val
        }).then((response) => {
          let {data} = response
          if (response.status == 200) {
            if (val.length == 4) {
              this.cityOptions = data
              this.form.customCompForm.city = ''
              this.form.customCompForm.county = ''
              this.form.customCompForm.rural = ''
            } else if (val.length == 6) {
              this.countyOptions = data
              this.form.customCompForm.county = ''
              this.form.customCompForm.rural = ''
            } else {
              this.ruralOptions = data
              this.form.customCompForm.rural = ''
            }
          }
        })
      }
    },
    swithSelectComp() {
      this.form.customCompForm.province = ''
      this.form.customCompForm.city = ''
      this.form.customCompForm.county = ''
      this.form.customCompForm.rural = ''
      this.form.customCompForm.compName = ''
      this.form.isCustomComp = false
    },
    searchDepartment(queryString, cb) {
      if (!this.form.isCustomComp && this.form.company) {
        getdepartmentByOrgId({
          orgId: this.form.company
        }).then((response) => {
          let {data} = response
          if (response.status == 200) {
            this.departmentList = data
            var restaurants = this.departmentList
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
            // 调用 callback 返回建议列表的数据
            cb(results)
          }
        })
      } else {
        cb([])
      }
    },
    departmentSelect(item) {
      this.form.department = item.value
    },
    changePersonType(val) {
      this.form.specialtyId1 = ''
      this.form.specialtyId2 = ''
      getSpecialty1Indexs({personType: val}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.specialtyId1Options = data
        }
      })
    },
    changeSpecialtyId1(val) {
      this.form.specialtyId2 = ''
      getSpecialty2Indexs({specialtyId1: val}).then((response) => {
        let {data} = response
        if (response.status == 200) {
          this.specialtyId2Options = data
        }
      })
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.indexOf(queryString.toLowerCase()) >= 0)
      }
    },
    refreshCaptcha() {
      this.vcodeuuid = util.guid()
      this.captchaUrl = process.env.API_URL + 'api/public/captcha/captcha.jpg?key=' + this.vcodeuuid
    },
    // sendSmsMethod() {
    //   this.$refs.form.validateField('phone', error => {
    //     if (!error) {
    //       let timestamp = new Date().getTime()
    //       let sign = sha256(this.form.phone + 1 + timestamp).toString()
    //       let param = {
    //         mobile: this.form.phone,
    //         bType: 1,
    //         sign: sign,
    //         timestamp: timestamp
    //       }
    //       sendSms(param).then((response) => {
    //         let {data} = response
    //         if (response.status == 200) {
    //           if (data.status == 200) {
    //             this.$message({
    //               message: data.msg,
    //               type: 'success'
    //             })
    //             this.time = 60
    //             this.smsTimer()
    //           } else {
    //             this.$message({
    //               message: data.msg,
    //               type: 'warning'
    //             })
    //           }
    //         } else {
    //           this.$message.error('网络错误！')
    //         }
    //       })
    //     }
    //   })
    // },
    // smsTimer() {
    //   if (this.time > 0) {
    //     this.time--
    //     setTimeout(this.smsTimer, 1000)
    //   }
    // },
    registerSuccessTimer() {
      if (this.registerSuccessTime > 0) {
        this.registerSuccessTime--
        setTimeout(this.registerSuccessTimer, 1000)
        this.registerText = '注册成功，' + this.registerSuccessTime + '秒后返回首页！'
      } else {
        window.location.href = '/'
      }
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid && !this.registerLoading) {
          this.registerLoading = true
          let param = {
            username: this.form.username,
            password: md5(this.form.password).toString(),
            realname: this.form.realname,
            sex: this.form.sex,
            credentialsType: this.form.cardType,
            sertId: this.form.sertId,
            // mobile: this.form.phone,
            mobile: this.form.mobile,
            isMobileVerify: 1,
            personType: this.form.personType,
            specialtyId1: this.form.specialtyId1,
            specialtyId2: this.form.specialtyId2,
            title: this.form.title,
            countryDoctor: this.form.countryDoctor, // 乡村医生
            inputType: 1,
            isCustomComp: this.form.isCustomComp,
            department: this.form.department,
            // code: this.form.vPhoneCode
            mobileCode: this.form.mobileCode
          }
          if (this.form.isCustomComp) {
            param.province = this.form.customCompForm.province
            param.city = this.form.customCompForm.city
            param.county = this.form.customCompForm.county
            param.rural = this.form.customCompForm.rural
            param.companyName = this.form.customCompForm.compName
          } else {
            param.orgId = this.form.company
          }
          
          let paramyzm = {
            mobile: this.form.mobile,
            code: this.form.mobileCode
          }
          smsvalidate(paramyzm).then((res) => {
            
            studyRegister(param).then(({data}) => {
              if (data.code == 0) {
                this.registerSuccessTimer()
              } else {
                this.$message({
                  message: data.msg,
                  type: 'warning'
                })
              }
            })
          }).catch(res => {
            this.registerLoading = false
          })
          
          // studyRegister(param).then((response) => {
          //   let {data} = response
          //   if (response.status == 200) {
          //     if (data.status == 200) {
          //       this.userLogin({
          //         username: this.form.username,
          //         password: this.form.password
          //       }).then((data) => {
          //         if (data.success) {
          //           this.registerSuccessTimer()
          //         } else {
          //           this.$message(data.msg)
          //         }
          //       }).catch((error) => {
          //         this.$message.error('登录异常！')
          //       })
          //     } else {
          //       this.$message({
          //         message: data.msg,
          //         type: 'warning'
          //       })
          //     }
          //   } else {
          //     this.$message.error('网络错误！')
          //   }
          // })
        } else {
          setTimeout(function () {
            let jump = document.getElementsByClassName('el-form-item__error')
            document.documentElement.scrollTop = document.body.scrollTop = jump[0].parentNode.offsetTop
          }, 50)
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.verifyMain {
  position: absolute;
  top: -160px;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue